<template>
  <div>
    
        <hr-dialog
            width='80%'
            :visible.sync="dialogVisible"
            :title="title"
            :handleClose='handleClose'
        >
            <template slot="body">
              <div>
                <el-form
                  :disabled="disabled"
                  ref="registerForm"
                  :model="form"
                  label-width="120px"
                  margin-top="10px"
                  margin-right="5px"
                  :rules="rules"
                >
                  <el-row>
                    <el-col :span="8">
                      <el-form-item
                        label="停车场"
                        prop="parkingLotId"
                        :rules="[{ required: true, message: '请选择停车场', trigger: 'blur' }]"
                      >
                            <!-- :disabled="item.disabled" -->
                        <el-select :disabled="edit" @change="spaceIdChange" v-model="regForm.spaceId" style="width: 100%">
                          <el-option
                            style="padding-left: 10px"
                            v-for="item in parkingLotList"
                            :key="item.id"
                            :label="item.title"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="车辆身份"
                        prop="carManageType"
                        :rules="[{ required: true, message: '请选择车辆身份', trigger: 'blur' }]"
                      >
                        <el-select @change="carManageTypeChange" :disabled="edit" v-model="regForm.carManageType" style="width: 100%">
                          <el-option
                            style="padding-left: 10px"
                            v-for="item in carManageTypeList"
                            :key="item.dictKey"
                            :label="item.dictValue"
                            :value="item.dictKey"
                            :disabled="item.disabled"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="车牌号">
                        <el-input :disabled="edit" v-model="regForm.ruleName"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="车型大小"
                        prop="bigOrSmallCar"
                        :rules="[{ required: true, message: '请选择车型大小', trigger: 'blur' }]"
                      >
                        <el-select :disabled="edit" v-model="regForm.bigOrSmallCar" style="width: 100%">
                          <el-option
                            style="padding-left: 10px"
                            v-for="item in bigOrSmallCarList"
                            :key="item.dictKey"
                            :label="item.dictValue"
                            :value="item.dictKey"
                            :disabled="item.disabled"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="主/副车"
                        prop="isMainCar"
                        :rules="[{ required: true, message: '请选择主/副车', trigger: 'blur' }]"
                      >
                        <el-select :disabled="edit" v-model="regForm.isMainCar" style="width: 100%">
                          <el-option
                            style="padding-left: 10px"
                            v-for="item in mainCarList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            :disabled="item.disabled"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="车位编号">
                        <el-input :disabled="edit" v-model="regForm.regionNames">
                          <el-button @click="selectCarCode" slot="append" type="primary">选择</el-button>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="车主">
                        <el-input :disabled="edit" v-model="regForm.ruleName"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="车主电话">
                        <el-input :disabled="edit" v-model="regForm.ruleName"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="楼栋/单元"
                        prop="buildingId"
                        :rules="[{ required: true, message: '请选择楼栋/单元', trigger: 'blur' }]"
                      >
                        <el-select :disabled="edit"
                        @change="buildingIdChange"
                         v-model="regForm.buildingId" style="width: 100%">
                          <el-option
                            style="padding-left: 10px"
                            v-for="item in buildingList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            :disabled="item.disabled"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="房间名称"
                        prop="roomId"
                        :rules="[{ required: true, message: '请选择房间名称', trigger: 'blur' }]"
                      >
                        <el-select :disabled="edit" v-model="regForm.roomId" style="width: 100%">
                          <el-option
                            style="padding-left: 10px"
                            v-for="item in roomList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            :disabled="item.disabled"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="收费套餐"
                        prop="carFeeRuleId"
                        :rules="[{ required: true, message: '请选择收费套餐', trigger: 'blur' }]"
                      >
                        <el-select :disabled="edit" @change="carFeeRuleIdChange" v-model="regForm.feeRuleId" style="width: 100%">
                          <el-option
                            style="padding-left: 10px"
                            v-for="item in carRuleList"
                            :key="item.id"
                            :label="item.setmealName"
                            :value="item.id"
                            :disabled="item.disabled"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="租赁起期">
                        <!-- <el-input :disabled="edit" v-model="regForm.ruleName"></el-input> -->
                        <el-date-picker
                          @change="effectTimeChange"
                          v-model="regForm.effectTime"
                          type="date"
                          placeholder="选择日期">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="租赁时长"
                        prop="cycleNum"
                        :rules="[{ required: true, message: '请选择租赁时长', trigger: 'blur' }]"
                      >
                        <el-select :disabled="edit" 
                        
                        @change="cycleNumChange"
                        v-model="regForm.cycleNum" style="width: 100%">
                          <el-option
                            style="padding-left: 10px"
                            v-for="item in cycleNumList"
                            :key="item.dictKey"
                            :label="item.dictValue"
                            :value="item.dictKey"
                            :disabled="item.disabled"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="租赁止期">
                        <el-input :disabled="true||edit" v-model="regForm.expiredTime"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="优惠方案"
                        prop="parkingLotId"
                        :rules="[{ required: true, message: '请选择优惠方案', trigger: 'blur' }]"
                      >
                        <el-select :disabled="edit" @change="discountRuleIdChange" v-model="regForm.discountRuleId" style="width: 100%">
                          <el-option
                            style="padding-left: 10px"
                            v-for="item in carRuleDiscountList"
                            :key="item.id"
                            :label="item.discountName"
                            :value="item.id"
                            :disabled="item.disabled"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="优惠金额">
                        <el-input :disabled="true||edit" v-model="regForm.discountAmount"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="应收金额">
                        <el-input :disabled="true||edit" v-model="regForm.shouldAmount"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="实收金额">
                        <el-input :disabled="true||edit" v-model="regForm.payAmount"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item
                        label="授权区域"
                        prop="parkingLotId"
                        :rules="[{ required: true, message: '请选择授权区域', trigger: 'blur' }]"
                      >
                        <el-select :disabled="edit" v-model="regForm.parkingLotId" style="width: 100%">
                          <el-option
                            style="padding-left: 10px"
                            v-for="item in parkingLotList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            :disabled="item.disabled"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="备注说明">
                        <el-input :disabled="edit" v-model="regForm.description" type="textarea"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24"> </el-col>
                  </el-row>
                </el-form>
              </div>
            </template>
            <template slot="footer">
                    <div class="btnArea" style="text-align:right;margin-right:24px">
                       <!-- v-if="isEdit" -->
                        <el-button size="small" type="primary" icon="el-icon-circle-plus-outline"  @click="submitRecord" style="margin-right: 20px"
                        >保存</el-button>
                        <!-- v-if="isEdit" -->
                        <el-button @click="closeRecord" size="small" icon="el-icon-circle-close">取消</el-button>
                        
                        <!-- v-if="cancelBtn" -->
                    </div>
            </template>
        </hr-dialog>
        
        <hr-dialog
            width='80%'
            :visible.sync="showCarCodeFlag"
            :title="'车辆编码'"
            :handleClose='handleCloseCarCodeFlag'
        >
            <template slot="body">
                <div>
                  <!-- dawdaw -->
                    <!-- :form="registerForm" -->
                  <parkvihicleCarCode
                    v-if="showCarCodeFlag"
                    :spaceId="regForm.spaceId"
                    @getCarCode="getCarCode"
                  >
                  </parkvihicleCarCode>
                </div>
            </template>
            <template slot="footer">
                    <div class="btnArea" style="text-align:right;margin-right:24px">
                       <!-- v-if="isEdit" -->
                        <el-button size="small" type="primary" icon="el-icon-circle-plus-outline"  @click="selectConfirm" style="margin-right: 20px"
                        >确定</el-button>
                        <!-- v-if="isEdit" -->
                        <el-button @click="closeCarCodeRecord" size="small" icon="el-icon-circle-close">取消</el-button>
                        
                        <!-- v-if="cancelBtn" -->
                    </div>
            </template>
        </hr-dialog>
        <!-- <parkvihicleCarCode
          :showCarCodeFlag.sync="showCarCodeFlag"
          :handleCloseCarCodeFlag='handleCloseCarCodeFlag'
          :title="'快速登记'"
          :form="registerForm"
        >
        </parkvihicleCarCode> -->
  </div>
</template>

<script>
import {
  getBuildingList,
  getRoomList,
  getCarRuleList,
  getCarRuleDiscountList,
} from './parkvehicle';
import _ from 'lodash';
  import {
  getSpaceList
   } from "@/api/v4ward/pay/paylog";
import { getDictionaryWithIntKey } from '@/api/common';
import parkvihicleCarCode from '@/views/v4ward/park/vehiclev3/parkvehicle-carcode';
export default {
  components: {
    parkvihicleCarCode,
  },
  props:{
      handleClose:{
          default:()=>{},
      },
      form: {
        default: {
          projectId: '',
          attachList: [],
        },
      },
      title:{
          default:'',
          type:String,
      },
      spaceId:{
          default:'',
          type:String,
      },
      dialogVisible:{
          default:false,
          type:Boolean,
      },
  },
  data() {
    return {
      // form: {},
      showCarCodeFlag:false,
      buildingList: [],
      roomList: [],
      mainCarList:[{
        label:'副车',
        value:0,
      },{
        label:'主车',
        value:1,
      }],
      regForm: {
        spaceId:'',
      },
      carManageTypeList:[],
      bigOrSmallCarList:[],
      cycleNumList:[],
      carRuleDiscountList:[],
      carRuleList:[],
      parkingLotList:[],
    }
  },
  created() {},
  mounted() {
    this.initAllSelectionList();
  },
  methods: {
    buildingIdChange(val){
      getRoomList({buildingId:val}).then(res=>{
        this.roomList = res.data;
      });
    },
    getCarCode(val){
      console.log(val);
      this.regForm.parkingSpaceIds = val[0];
      this.regForm.regionNames = val[1];
    },
    getShouldAmount(val){
      let amount = ''
      this.carRuleList.forEach((ele)=>{
        if(ele.id===val)amount = ele.costPrice
      })
      this.regForm.shouldAmount = amount;
    },
    getDiscountAmount(val){
      let amount = ''
      this.carRuleDiscountList.forEach((ele)=>{
        if(ele.id===val)amount = ele.discountNumber
      })
      this.regForm.discountAmount = amount;
    },
    cycleNumChange(val){
      this.regForm.expiredTime = this.dayjs(this.dayjs(this.regForm.effectTime).format('YYYY-MM-DD')).add(val, 'month').format('YYYY-MM-DD');
    },
    spaceIdChange(val){
      // this.carManageTypeChange(this.regForm.carManageType);
      this.regForm = {spaceId:val};

        getBuildingList({spaceId:this.regForm.spaceId}).then(res => {
          this.buildingList = res.data
        });
    },
    carFeeRuleIdChange(val){
      getCarRuleDiscountList({spaceId:this.spaceId,carFeeRuleId:val}).then((res)=>{
        this.carRuleDiscountList = res.data;
        this.getShouldAmount(val);
      })
    },
    discountRuleIdChange(val){
      this.getDiscountAmount(val);
      console.log(Number(this.regForm.shouldAmount),Number(this.regForm.discountAmount));
      this.regForm.payAmount = Number(this.regForm.shouldAmount)-Number(this.regForm.discountAmount) 
    },
    carManageTypeChange(val){
      getCarRuleList({spaceId:this.spaceId,packageType:val}).then((res)=>{
        this.carRuleList = res.data;
      })
    },
    selectConfirm(){

      this.showCarCodeFlag = false;
    },
    closeCarCodeRecord(){
      this.regForm.regionNames = '';
      this.regForm.parkingSpaceIds = '';
      this.showCarCodeFlag = false;
    },
    handleCloseCarCodeFlag(){
      this.closeCarCodeRecord();
    },
    selectCarCode(){
      this.showCarCodeFlag = true;
    },
    initAllSelectionList() {
      getSpaceList().then(res => {
        this.parkingLotList = res.data;
        this.form.spaceId = this.spaceId;
        this.regForm = _.cloneDeep(this.form);
        getBuildingList({spaceId:this.regForm.spaceId}).then(res => {
          this.buildingList = res.data
        });
        // this.regForm.spaceId = this.spaceId;
      })
      getDictionaryWithIntKey('park_fee_cycle').then((data) => {
        this.cycleNumList = data.data;
      });
      getDictionaryWithIntKey('car_type_v2').then((data) => {
        this.bigOrSmallCarList = data.data;
      });
      getDictionaryWithIntKey('car_manage_type').then((data) => {
        this.carManageTypeList = data.data;
      });
    }
  }
}
</script>

<style>

</style>